export default __webpack_public_path__ + "static/media/shield_security2.6381903f.svg";